import React from "react";
import styled from "styled-components";
import { EditableText } from "../../../designSystem/compositeComponents/EditableText";
import { SuggesterTextInput } from "../../../designSystem/inputs/SuggesterTextInput";
import { TextArea } from "../../../designSystem/inputs/TextArea";
import { TextAreaWithSave } from "../../../designSystem/inputs/TextAreaWithSave";
import { TextInput } from "../../../designSystem/inputs/TextInput";
import { TextInputWithSave } from "../../../designSystem/inputs/TextInputWithSave";
import { EditableTextArea } from "../../../designSystem/compositeComponents/EditableTextArea";
import { SuggesterTextInputWithSave } from "../../../designSystem/inputs/SuggesterTextInputWithSave";

export const TextInputOverview = (): JSX.Element => 
{
    const [text, setText] = React.useState('');

    function handleCancel()
    {
        alert('restoring value');
    }

    function handleSave(value:string)
    {
        alert('saving value:' + value);
        setText(value);
    }

    const suggesterOptions = [
        { identifier:'a1', text:'apple' },
        { identifier:'a2', text:'apricot' },
        { identifier:'a3', text:'avocado' },
        { identifier:'b1', text:'banana' },
        { identifier:'b2', text:'blackberry' },
        { identifier:'b3', text:'blueberry' },
        { identifier:'c1', text:'cherry' },
        { identifier:'c2', text:'coconut' },
        { identifier:'c3', text:'cranberry' }
    ];

    const filteredOptions = text === '' 
        ? suggesterOptions.slice(0, 3) 
        : suggesterOptions.filter(o => 
            o.text.toLowerCase().includes(text.toLowerCase())
        );

    return (
        <>
            <h2>EditableText</h2>

            <Container>
                <div>
                    <EditableText
                        ariaLabel="H1 editable text with validation error"
                        value={text}
                        onSave={(value) => setText(value)}
                        styleMode='H1'
                        validator={(value) => (value.length < 5 ? {valid:true} : {valid:false, errorMessage:'errormessage here'}) }
                        placeholder="H1 editable text with validation error" />
                </div>
                <div>
                    <EditableText
                        ariaLabel="H1 editable text"
                        value={text}
                        onSave={(value) => setText(value)}
                        styleMode='H1'
                        validator={(value) => (value.length < 5 ? {valid:true} : {valid:false, errorMessage:'errormessage here'}) }
                        placeholder="H1 editable text" />
                </div>
                <Row>
                    <EditableText
                        ariaLabel="H2 editable text"
                        value={text}
                        onSave={(value) => setText(value)}
                        styleMode='H2'
                        validator={(value) => (value.length < 5 ? {valid:true} : {valid:false, errorMessage:'errormessage here'}) }
                        placeholder="H2 editable text" />
                </Row>
                <Row>
                    <EditableText
                        ariaLabel="H3 editable text"
                        value={text}
                        onSave={(value) => setText(value)}
                        styleMode='H3'
                        validator={(value) => (value.length < 5 ? {valid:true} : {valid:false, errorMessage:'errormessage here'}) }
                        placeholder="H3 editable text" />
                </Row>

                <Row>
                    <EditableText
                        ariaLabel="H4 editable text"
                        value={text}
                        onSave={(value) => setText(value)}
                        styleMode='H4'
                        validator={(value) => (value.length < 5 ? {valid:true} : {valid:false, errorMessage:'errormessage here'}) }
                        placeholder="H4 editable text"/>
                </Row>

                <Row>
                    <EditableText
                        ariaLabel="Default editable text"
                        value={text}
                        onSave={(value) => setText(value)}
                        styleMode='default'
                        validator={(value) => (value.length < 5 ? {valid:true} : {valid:false, errorMessage:'errormessage here'}) }
                        placeholder="Default editable text"/>
                </Row>

                <Row>
                    <EditableText
                        ariaLabel="Default editable text"
                        value={text}
                        onSave={(value) => setText(value)}
                        styleMode='default'
                        validator={(value) => (value.length < 5 ? {valid:true} : {valid:false, errorMessage:'errormessage here'}) }
                        placeholder="Default editable text (14px)"
                        fontSize={14}/>
                </Row>

                <h3>errorstate set</h3>
                <Row>
                    <EditableText
                        ariaLabel="editable text without validation"
                        value={text}
                        onSave={(value) => setText(value)}
                        placeholder="Indtast venligst overskrift"
                        inErrorState/>
                </Row>

                <h3>no validation</h3>
                <Row>
                    <EditableText
                        ariaLabel="editable text without validation"
                        value={text}
                        onSave={(value) => setText(value)}
                        placeholder="Indtast venligst overskrift"/>
                </Row>

                <h3>disabled</h3>
                <Row>
                    <EditableText
                        ariaLabel="editable text, disabled"
                        value={text}
                        onSave={(value) => setText(value)}
                        disabled
                        validator={(value) => (value.length < 5 ? {valid:true} : {valid:false, errorMessage:'errormessage here'}) }
                        placeholder="Indtast venligst overskrift"/>
                </Row>
            </Container>

            <h2>EditableTextArea</h2>
            <Container>
                <Row>
                    <EditableTextArea
                        ariaLabel="editable textarea"
                        value={text}
                        onSave={(value) => setText(value)}
                        validator={(value) => (value.length < 5 ? {valid:true} : {valid:false, errorMessage:'errormessage here'}) }
                        placeholder="Indtast en tekst" />
                </Row>
                <h3>errorstate set</h3>
                <Row>
                    <EditableTextArea
                        ariaLabel="editable textarea without validation"
                        value={text}
                        onSave={(value) => setText(value)}
                        placeholder="textarea"
                        inErrorState />
                </Row>
                <h3>no validation</h3>
                <Row>
                    <EditableTextArea
                        ariaLabel="editable textarea without validation"
                        value={text}
                        onSave={(value) => setText(value)}
                        placeholder="textarea" />
                </Row>
                <h3>disabled</h3>
                <Row>
                    <EditableTextArea
                        ariaLabel="editable textarea, disabled"
                        value={text}
                        onSave={(value) => setText(value)}
                        disabled
                        validator={(value) => (value.length < 5 ? {valid:true} : {valid:false, errorMessage:'errormessage here'}) }
                        placeholder="textarea" />
                </Row>
            </Container>

            <h2>Suggester TextInput</h2>
            <Container>
                <Row>
                    <SuggesterTextInput 
                        text={text} 
                        visibleOptions={filteredOptions} 
                        onChange={(value) => setText(value)} 
                        onSelectOption={(selection)=>alert(JSON.stringify(selection))} 
                    />
                </Row>
            </Container>
            <h2>Suggester TextInput with save</h2>
            <Container>
                <Row>
                    <SuggesterTextInputWithSave
                        value={text}
                        visibleOptions={filteredOptions}
                        onSave={handleSave}
                        onCancel={handleCancel}
                        onSelectOption={(selection)=>alert(JSON.stringify(selection))}
                    />
                </Row>
            </Container>
            <h2>Basic TextInput</h2>
            <Container>
                <Row>
                    <TextInput value={text} onChange={setText} />
                    <TextInput value={text} onChange={setText} disabled={true} />
                    <TextInput value={text} onChange={setText} placeholder="her kommer tekst..." />
                    <TextInput value={text} onChange={setText} placeholder="her kommer tekst..." disabled={true} />
                </Row>
                <Row>
                    <TextInput value={text} onChange={setText} inErrorState={true} />
                    <TextInput value={text} onChange={setText} inErrorState={true} disabled={true} />
                    <TextInput value={text} onChange={setText} inErrorState={true} placeholder="her kommer tekst..." />
                    <TextInput value={text} onChange={setText} inErrorState={true} placeholder="her kommer tekst..." disabled={true} />
                </Row>      
                <Row>
                    <TextInput value={text} onChange={setText} leadingIcon={"navigation_settings"} />
                    <TextInput value={text} onChange={setText} leadingIcon={"navigation_settings"} disabled={true} />
                    <TextInput value={text} onChange={setText} leadingIcon={"navigation_settings"} placeholder="her kommer tekst..." />
                    <TextInput value={text} onChange={setText} leadingIcon={"navigation_settings"} placeholder="her kommer tekst..." disabled={true} />
                </Row>
                <Row>
                    <TextInput value={text} onChange={setText} leadingIcon={"navigation_settings"} inErrorState={true} />
                    <TextInput value={text} onChange={setText} leadingIcon={"navigation_settings"} inErrorState={true} disabled={true} />
                    <TextInput value={text} onChange={setText} leadingIcon={"navigation_settings"} inErrorState={true} placeholder="her kommer tekst..." />
                    <TextInput value={text} onChange={setText} leadingIcon={"navigation_settings"} inErrorState={true} placeholder="her kommer tekst..." disabled={true} />
                </Row>
                <Row>
                    <TextInput value={text} onChange={setText} trailingIcon={"navigation_home"} />
                    <TextInput value={text} onChange={setText} trailingIcon={"navigation_home"} disabled={true} />
                    <TextInput value={text} onChange={setText} trailingIcon={"navigation_home"} placeholder="her kommer tekst..." />
                    <TextInput value={text} onChange={setText} trailingIcon={"navigation_home"} placeholder="her kommer tekst..." disabled={true} />
                </Row>
                <Row>
                    <TextInput value={text} onChange={setText} trailingIcon={"navigation_home"} inErrorState={true} />
                    <TextInput value={text} onChange={setText} trailingIcon={"navigation_home"} inErrorState={true} disabled={true} />
                    <TextInput value={text} onChange={setText} trailingIcon={"navigation_home"} inErrorState={true} placeholder="her kommer tekst..." />
                    <TextInput value={text} onChange={setText} trailingIcon={"navigation_home"} inErrorState={true} placeholder="her kommer tekst..." disabled={true} />
                </Row>
                <Row>
                    <TextInput value={text} onChange={setText} leadingIcon={"navigation_settings"} trailingIcon={"navigation_home"} />
                    <TextInput value={text} onChange={setText} leadingIcon={"navigation_settings"} trailingIcon={"navigation_home"} disabled={true} />
                    <TextInput value={text} onChange={setText} leadingIcon={"navigation_settings"} trailingIcon={"navigation_home"} placeholder="her kommer tekst..." />
                    <TextInput value={text} onChange={setText} leadingIcon={"navigation_settings"} trailingIcon={"navigation_home"} placeholder="her kommer tekst..." disabled={true} />
                </Row>
                <Row>
                    <TextInput value={text} onChange={setText} leadingIcon={"navigation_settings"} trailingIcon={"navigation_home"} inErrorState={true} />
                    <TextInput value={text} onChange={setText} leadingIcon={"navigation_settings"} trailingIcon={"navigation_home"} inErrorState={true} disabled={true} />
                    <TextInput value={text} onChange={setText} leadingIcon={"navigation_settings"} trailingIcon={"navigation_home"} inErrorState={true} placeholder="her kommer tekst..." />
                    <TextInput value={text} onChange={setText} leadingIcon={"navigation_settings"} trailingIcon={"navigation_home"} inErrorState={true} placeholder="her kommer tekst..." disabled={true} />
                </Row>
            </Container>

            <h2>TextInput with save</h2>
            <Container>
                <Row>
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} />
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} disabled={true} />
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} placeholder="her kommer tekst..." />
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} placeholder="her kommer tekst..." disabled={true} />
                </Row>
                <Row>
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} inErrorState={true} />
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} inErrorState={true} disabled={true} />
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} inErrorState={true} placeholder="her kommer tekst..." />
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} inErrorState={true} placeholder="her kommer tekst..." disabled={true} />
                </Row>      
                <Row>
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} leadingIcon={"navigation_settings"} />
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} leadingIcon={"navigation_settings"} disabled={true} />
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} leadingIcon={"navigation_settings"} placeholder="her kommer tekst..." />
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} leadingIcon={"navigation_settings"} placeholder="her kommer tekst..." disabled={true} />
                </Row>
                <Row>
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} leadingIcon={"navigation_settings"} inErrorState={true} />
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} leadingIcon={"navigation_settings"} inErrorState={true} disabled={true} />
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} leadingIcon={"navigation_settings"} inErrorState={true} placeholder="her kommer tekst..." />
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} leadingIcon={"navigation_settings"} inErrorState={true} placeholder="her kommer tekst..." disabled={true} />
                </Row>
                <Row>
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} trailingIcon={"navigation_home"} />
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} trailingIcon={"navigation_home"} disabled={true} />
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} trailingIcon={"navigation_home"} placeholder="her kommer tekst..." />
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} trailingIcon={"navigation_home"} placeholder="her kommer tekst..." disabled={true} />
                </Row>
                <Row>
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} trailingIcon={"navigation_home"} inErrorState={true} />
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} trailingIcon={"navigation_home"} inErrorState={true} disabled={true} />
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} trailingIcon={"navigation_home"} inErrorState={true} placeholder="her kommer tekst..." />
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} trailingIcon={"navigation_home"} inErrorState={true} placeholder="her kommer tekst..." disabled={true} />
                </Row>
                <Row>
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} leadingIcon={"navigation_settings"} trailingIcon={"navigation_home"} />
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} leadingIcon={"navigation_settings"} trailingIcon={"navigation_home"} disabled={true} />
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} leadingIcon={"navigation_settings"} trailingIcon={"navigation_home"} placeholder="her kommer tekst..." />
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} leadingIcon={"navigation_settings"} trailingIcon={"navigation_home"} placeholder="her kommer tekst..." disabled={true} />
                </Row>
                <Row>
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} leadingIcon={"navigation_settings"} trailingIcon={"navigation_home"} inErrorState={true} />
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} leadingIcon={"navigation_settings"} trailingIcon={"navigation_home"} inErrorState={true} disabled={true} />
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} leadingIcon={"navigation_settings"} trailingIcon={"navigation_home"} inErrorState={true} placeholder="her kommer tekst..." />
                    <TextInputWithSave value={text} onSave={handleSave} onCancel={handleCancel} leadingIcon={"navigation_settings"} trailingIcon={"navigation_home"} inErrorState={true} placeholder="her kommer tekst..." disabled={true} />
                </Row>
            </Container>

            <h2>Basic TextArea</h2>
            <Container>
                <Row>
                    <TextArea value={text} onChange={setText} />
                    <TextArea value={text} onChange={setText} disabled={true}  />
                    <TextArea value={text} onChange={setText} inErrorState={true} />
                    <TextArea value={text} onChange={setText} inErrorState={true} disabled={true}  />
                </Row>
                <Row>
                    <TextArea value={text} onChange={setText} placeholder="her kommer tekst..." />
                    <TextArea value={text} onChange={setText} placeholder="her kommer tekst..." disabled={true}  />
                    <TextArea value={text} onChange={setText} placeholder="her kommer tekst..." inErrorState={true} />
                    <TextArea value={text} onChange={setText} placeholder="her kommer tekst..." inErrorState={true} disabled={true}  />
                </Row>
                <Row>
                    <TextArea value={text} onChange={setText} minRows={5} />
                    <TextArea value={text} onChange={setText} minRows={5} disabled={true}  />
                    <TextArea value={text} onChange={setText} minRows={5} inErrorState={true} />
                    <TextArea value={text} onChange={setText} minRows={5} inErrorState={true} disabled={true}  />
                </Row>
                <Row>
                    <TextArea value={text} onChange={setText} minRows={5} placeholder="her kommer tekst..." />
                    <TextArea value={text} onChange={setText} minRows={5} placeholder="her kommer tekst..." disabled={true}  />
                    <TextArea value={text} onChange={setText} minRows={5} placeholder="her kommer tekst..." inErrorState={true} />
                    <TextArea value={text} onChange={setText} minRows={5} placeholder="her kommer tekst..." inErrorState={true} disabled={true}  />
                </Row>
            </Container>

            <h2>TextArea with save</h2>
            <Container>
                <Row>
                    <TextAreaWithSave value={text} onSave={handleSave} onCancel={handleCancel} />
                    <TextAreaWithSave value={text} onSave={handleSave} onCancel={handleCancel} disabled={true}  />
                    <TextAreaWithSave value={text} onSave={handleSave} onCancel={handleCancel} inErrorState={true} />
                    <TextAreaWithSave value={text} onSave={handleSave} onCancel={handleCancel} inErrorState={true} disabled={true}  />
                </Row>
                <Row>
                    <TextAreaWithSave value={text} onSave={handleSave} onCancel={handleCancel} placeholder="her kommer tekst..." />
                    <TextAreaWithSave value={text} onSave={handleSave} onCancel={handleCancel} placeholder="her kommer tekst..." disabled={true}  />
                    <TextAreaWithSave value={text} onSave={handleSave} onCancel={handleCancel} placeholder="her kommer tekst..." inErrorState={true} />
                    <TextAreaWithSave value={text} onSave={handleSave} onCancel={handleCancel} placeholder="her kommer tekst..." inErrorState={true} disabled={true}  />
                </Row>
                <Row>
                    <TextAreaWithSave value={text} onSave={handleSave} onCancel={handleCancel} minRows={5} />
                    <TextAreaWithSave value={text} onSave={handleSave} onCancel={handleCancel} minRows={5} disabled={true}  />
                    <TextAreaWithSave value={text} onSave={handleSave} onCancel={handleCancel} minRows={5} inErrorState={true} />
                    <TextAreaWithSave value={text} onSave={handleSave} onCancel={handleCancel} minRows={5} inErrorState={true} disabled={true}  />
                </Row>
                <Row>
                    <TextAreaWithSave value={text} onSave={handleSave} onCancel={handleCancel} minRows={5} placeholder="her kommer tekst..." />
                    <TextAreaWithSave value={text} onSave={handleSave} onCancel={handleCancel} minRows={5} placeholder="her kommer tekst..." disabled={true}  />
                    <TextAreaWithSave value={text} onSave={handleSave} onCancel={handleCancel} minRows={5} placeholder="her kommer tekst..." inErrorState={true} />
                    <TextAreaWithSave value={text} onSave={handleSave} onCancel={handleCancel} minRows={5} placeholder="her kommer tekst..." inErrorState={true} disabled={true}  />
                </Row>
            </Container>
        </>
    )
}

const Container = styled.div`
    margin-bottom: 20px;
    padding: 20px;
    border: 1px solid #888;
`;

const Row = styled.div`
    gap:10px;
    margin-bottom:5px;
    display: flex;
    flex-direction: row;
    align-items: stretch;

    & > * {
        flex-grow: 1;
    }
`;